import { render } from "./ClickThrough.vue?vue&type=template&id=f06fdf36&scoped=true"
import script from "./ClickThrough.vue?vue&type=script&lang=js"
export * from "./ClickThrough.vue?vue&type=script&lang=js"

import "./ClickThrough.vue?vue&type=style&index=0&id=f06fdf36&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f06fdf36"]])

export default __exports__